// extracted by mini-css-extract-plugin
export default {"uniformSizeItem":"UniformSizeItem_uniformSizeItem__3kDxJ","right":"UniformSizeItem_right__hlEsI","price":"UniformSizeItem_price__UsBdp","selector":"UniformSizeItem_selector__2OwZj"};